export default {
  root: {
    height: 6,
    background: ({ gradientTicks }) =>
      `linear-gradient(to right, ${gradientTicks.join(', ')})`,
  },
};
